export const defaultEconomicsSettings = {
  startDate: '',
  priceOil: [],
  priceGas: [],
  priceCondensate: [],
  pricePropane: [],
  priceButane: [],
  pricePentanes: [],
  opexVariableOil: 1,
  opexVariableGas: 1,
  opexVariableCondensate: 1,
  opexVariableWater: 0,
  opexFixed: 5000,
  royalty: 0.09,
  adValorem: 0,
  abandonment: 50000,
  abandonmentDelay: 60,
  priceEscalation: 0,
  costEscalation: 0,
  ownership: 1,
  ownershipCost: 1,
  ownershipCapex: 1,
  mcfToMmbtu: 1,
  cadToUsd: 0.79,
  cutoff: 100,
  currency: 'cad',
  units: 'field',
  consolidation: 'full-cycle',
  priceOffsetOil: 0,
  priceOffsetGas: 0,
  priceOffsetCondensate: 0,
  priceOffsetPropane: 0,
  priceOffsetButane: 0,
  priceOffsetPentanes: 0,
  nglPropaneYield: 0,
  nglButaneYield: 0,
  nglPentanesYield: 0,
  nglGasShrinkage: 0,
  priceDeckName: '3 Consultants Average Escalating',
  discountRate: 0.05,
  cutoffMethod: 1,
  country: 'canada',
  provinceOrState: 'alberta',
  tangibleCapital: 1000000,
  salvageValue: 0,
  intangibleCapital: 1500000,
  ggDeduction: 1000,
  taxRate: 0.21,
  localTaxRate: 0.05
};